import { Trans } from "@lingui/react/macro";

import { SELLER } from "../lib/seller";
import { useSellerName } from "../lib/useSellerName";

type SellerDetailsProps = {
  className?: string;
};

// Реквизиты продавца одной строкой для подвала: ИП, ИНН, ОГРНИП и почта.
export const SellerDetails = ({ className }: SellerDetailsProps) => {
  const seller = useSellerName();
  const inn = SELLER.inn;
  const ogrnip = SELLER.ogrnip;
  return (
    <p className={className}>
      <Trans>
        {seller} · TIN {inn} · OGRNIP {ogrnip}
      </Trans>{" "}
      ·{" "}
      <a href={`mailto:${SELLER.email}`} className="text-subtle hover:text-accent-strong">
        {SELLER.email}
      </a>
    </p>
  );
};
